import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ContractParameters } from '../models/ContractParameters';
import { ContractDataService } from '../services/contract-data.service';
import { StagingContracts } from '../models/StagingContracts';
import { timer } from 'rxjs';
import { LocationType } from '../models/Enums';

@Component({
    selector: 'staging-contracts',
    templateUrl: 'staging-contracts.component.html',
    styles: [],
    standalone: false
})
export class StagingContractsComponent implements OnInit, OnChanges {

    constructor(private _contractDataService: ContractDataService) {

    }

    //@ViewChild('closeButton') closeButton;
    @Input() contractParameters: ContractParameters;
    errorMessage: string = '';
    locationType: string = 'Destination';
    loading: boolean = true;
    contracts: StagingContracts = new StagingContracts();

    getContracts() {
        if (this.contractParameters.locCode.length === 0) {
            return;
        }

        this.locationType = this.contractParameters.locationType === LocationType.Origin ? "Origin" : "Destination";
        this.loading = true;
        this.contracts = new StagingContracts();

        this._contractDataService.getStagingContracts(this.contractParameters).subscribe({
            next: data => {
                this.contracts = data;
                this.loading = false;
            },
            error: err => this.errorMessage = err
        });
    }


    ngOnChanges(changes: SimpleChanges): void {
        if (changes['contractParameters']) {
            this.getContracts();
        }
    }

    ngOnInit(): void {
       
    }
    
}
